module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAALCAYAAABLcGxfAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAB3SURBVHgBjVABDYAwDFtQcglIuBSk4AAcAA5AwSVcwiUg4WzJnozny9akyba0fzcAA7XWiNyQL3L2iBqKRySxNKEmyiQSfWgGGqZOfFJeisH9McodkCty57qIByIYl8naspPieUR9gQWO9F/WYUrIG7zgX0I//wCKGN55l4PJZgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./images/send_icon.png
// module id = 22
// module chunks = 0